import { defineComponent, ref } from "vue";
export default defineComponent({
    name: "roomSearchInput",
    emits: ["search"],
    setup(props, { emit }) {
        const inputValue = ref("");
        const applyFilter = () => {
            emit("search", inputValue.value);
        };
        return {
            inputValue,
            applyFilter
        };
    }
});
